module.exports = __webpack_public_path__ + "img/ptpMachine.66b6ece4.svg";